import axios from "axios";
import ServiceHelper from "./serviceHelper";
import envConfig from "../config";
import i18n from "./i18n";
import { addToast } from "./toastService";
class ServiceOccurenceService {
  static Create(serviceOccurence) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    if (serviceOccurence.defaultImageId === "") {
      serviceOccurence.defaultImageId = null;
    }

    if (serviceOccurence.horseExternalId < 0) {
      serviceOccurence.horseExternalId = null;
    }

    return axios
      .post(`${envConfig.apiBaseUrl}/api/serviceOccurence/create`, serviceOccurence, config)
      .then((response) => {
        ServiceHelper.ApiCallPostValidation(response, "create");
        return response.data.data;
      })
      .catch((error) => {
        ServiceHelper.ApiCallPostCatchValidation(error);
        return false;
      });
  }

  static GetDetailServiceOccurence(serviceOccurenceExternalId) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .get(
        `${envConfig.apiBaseUrl}/api/serviceoccurence/detailserviceoccurence/${serviceOccurenceExternalId}`,
        config,
      )
      .then((response) => {
        var result = response.data.data;
        result.dateServiceOccurence = new Date(result.dateServiceOccurence);
        result.createdOn = new Date(result.createdOn);

        return result;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return;
        return;
      });
  }

  static DeleteServiceOccurence(serviceOccurenceExternalId) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .delete(
        `${envConfig.apiBaseUrl}/api/serviceoccurence/delete/${serviceOccurenceExternalId}`,
        config,
      )
      .then((response) => {
        ServiceHelper.ApiCallPostValidation(response, "delete");
        return response.data.data;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return;
        return;
      });
  }

  static DeleteNote(externalId) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .delete(`${envConfig.apiBaseUrl}/api/serviceoccurence/deleteNote/${externalId}`, config)
      .then((response) => {
        ServiceHelper.ApiCallPostValidation(response, "delete");
        return true;
      })
      .catch((error) => {
        console.log(error);
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return;
        return;
      });
  }

  static AddNote(note) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .post(`${envConfig.apiBaseUrl}/api/serviceoccurence/addNote`, note, config)
      .then((response) => {
        ServiceHelper.ApiCallPostValidation(response, "create");
        return true;
      })
      .catch((error) => {
        ServiceHelper.ApiCallPostCatchValidation(error);
        return false;
      });
  }

  static UpdateNote(externalId, editNote) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    editNote.externalId = externalId;

    return axios
      .post(`${envConfig.apiBaseUrl}/api/serviceOccurence/editNote`, editNote, config)
      .then((response) => {
        ServiceHelper.ApiCallPostValidation(response, "update");
        return response.data.success;
      })
      .catch((error) => {
        ServiceHelper.ApiCallPostCatchValidation(error);
        return false;
      });
  }

  static AddMedia(fileId, externalId) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    let postUrl = "";
    let obj = null;
    if (Array.isArray(fileId)) {
      postUrl = `${envConfig.apiBaseUrl}/api/serviceOccurence/addMedias`;
      obj = { fileIds: fileId, externalId };
    } else {
      postUrl = `${envConfig.apiBaseUrl}/api/serviceOccurence/addMedia`;
      obj = { fileId, externalId };
    }

    return axios
      .post(postUrl, obj, config)
      .then((response) => {
        return ServiceHelper.ApiCallPostValidation(response, "create");
      })
      .catch((error) => {
        ServiceHelper.ApiCallPostCatchValidation(error);
        return false;
      });
  }

  static async GenerateServiceReport(serviceOccurenceExternalId) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .get(`${envConfig.apiBaseUrl}/api/reports/service-summary/${serviceOccurenceExternalId}`, {
        ...config,
        responseType: "blob", // clé : on reçoit un binaire
      })
      .then(async (response) => {
        // ⚠️ Axios n’a pas de `response.ok` comme fetch
        // donc on teste le code HTTP :
        if (response.status < 200 || response.status >= 300) {
          throw response; // ira dans le catch
        }

        const contentType = response.headers["content-type"];

        // ✅ Cas 1 : PDF reçu
        if (contentType && contentType.includes("application/pdf")) {
          let filename = "rapport-services.pdf";
          const dispo = response.headers["content-disposition"];
          if (dispo) {
            const match = /filename\*=UTF-8''([^;]+)|filename="?([^"]+)"?/i.exec(dispo);
            filename = decodeURIComponent(match?.[1] || match?.[2] || filename);
          }

          const blob = new Blob([response.data], { type: "application/pdf" });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);

          return true;
        }

        // ⚠️ Cas 2 : pas un PDF => erreur JSON encapsulée dans un blob
        const text = await response.data.text();
        const error = JSON.parse(text);
        throw error; // ira dans le catch
      })
      .catch(async (error) => {
        // 🧠 Si l’erreur contient un blob JSON (backend)
        if (error?.response?.data instanceof Blob) {
          try {
            const text = await error.response.data.text();
            const errJson = JSON.parse(text);

            if (errJson.code === "CanGenerateReport") {
              const msg = i18n.t("Privilege.ValidationError.CanGenerateReport");
              const d = new Date();
              addToast(
                msg,
                "postValidationToast" + d.getSeconds() + d.getMilliseconds(),
                "ERROR",
                true,
              );
              return false;
            }

            // Autres erreurs renvoyées par le backend
            addToast(errJson.message || "Erreur inconnue", "error");
            return false;
          } catch (e) {
            console.error("Erreur de parsing JSON", e);
          }
        }

        // 🧱 Si c’est une erreur Axios ou autre
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (!ok) console.error(error);
        return false;
      });
  }

  static Update(serviceOccurence) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    if (serviceOccurence.defaultImageId === "") {
      serviceOccurence.defaultImageId = null;
    }

    return axios
      .post(`${envConfig.apiBaseUrl}/api/serviceoccurence/update`, serviceOccurence, config)
      .then((response) => {
        return ServiceHelper.ApiCallPostValidation(response, "update");
      })
      .catch((error) => {
        ServiceHelper.ApiCallPostCatchValidation(error);
        return false;
      });
  }
}

export default ServiceOccurenceService;
